import { ApiService } from '../../services/api_service';
import classNames from 'classnames';
import { ContextService } from '../../services/context_service';
import { getRoutingFromLocationHash } from '../../main/functions/locationHash';
import { lazyInject } from '../../services/inversify';
import { Md5 } from 'ts-md5/dist/md5';
import { Navigation } from '../../main/Navigation';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { SectionStyle } from '../../helpers/SectionStyle';
import style from './SideNavigation.less';
import { VeranstaltungsAuswahl } from '../../helpers/VeranstaltungsAuswahl';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

export interface SideNavigationProps {
    data: any;
    id: number;
    onRoutingChange: (routing: any) => void;
}

export interface SideNavigationState {
    backgroundColor: string;
    color: string;
    curNode: any;
    lastModul: any;
    navigation: any[];
    nodePath: any[];
    openItems: any;
}

export class SideNavigation extends React.Component<SideNavigationProps, SideNavigationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            backgroundColor: 'inherit',
            curNode: { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_KONFIGURATION },
            color: 'inherit',
            lastModul: null,
            navigation: null,
            openItems: {},
            nodePath: [],
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private lastVeranstaltungTid: number;

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any): void {
        const locationRouting: any = getRoutingFromLocationHash(window.location.hash, this.contextService) || {};
        const veranstaltungTid: number = VeranstaltungsAuswahl.tid;

        if (locationRouting.path && JSON.stringify(locationRouting) !== JSON.stringify(this.state.curNode)) {
            // console.info('componentDidUpdate()', JSON.stringify(this.state.curNode), JSON.stringify(locationRouting));
            const nodePath: any[] = new Navigation(this.props.data, this.apiService).getNodePath(locationRouting);
            this.setState({ curNode: locationRouting, nodePath }, () => this.setOpenItems(nodePath));
        }

        if (
            this.props.id !== prevProps.id
            || (this.props.data || {}).MODUL_SELECTED !== this.state.lastModul
            || veranstaltungTid !== this.lastVeranstaltungTid
        ) {
            this.init();
        }

        if (veranstaltungTid !== this.lastVeranstaltungTid) {
            this.lastVeranstaltungTid = veranstaltungTid;
        }
    }

    getNodeKey(item: any): string {
        return Md5.hashAsciiStr(JSON.stringify(item.path || {})).toString();
    }

    init(): void {
        const Navi: any = new Navigation(this.props.data, this.apiService, this.contextService);
        Navi.getData((navigation: any) => {
            const lastModul: string = (this.props.data || {}).MODUL_SELECTED;
            let node: any = navigation[this.props.id] || {};

            if (node.disabled) {
                const id: number = navigation.findIndex((item: any) => item.disabled !== true);

                if (id !== -1) {
                    node = navigation[id] || {};
                    this.props.onRoutingChange(node);
                    // console.info('ID-DISABLED', this.props.id, '->', id, navigation);
                }
            }
            const backgroundColor: string = node.bgcolor || this.state.backgroundColor;
            const color: string = node.color || this.state.color;
            this.setState({ backgroundColor, color, lastModul, navigation: node.children || [] }, () => {
                console.info('INIT:', this.props.id, this.state.navigation, node);
                let locationRouting: any = getRoutingFromLocationHash(window.location.hash, this.contextService)
                    || { path: { selectedMenu: this.props.id } };

                if (!locationRouting?.path.terminateOn) {
                    locationRouting = Navi.getNodeFallback(locationRouting);
                    this.props.onRoutingChange(locationRouting);
                    const nodePath: any[] = Navi.getNodePath(locationRouting);
                    this.setState({ nodePath }, () => this.setOpenItems(nodePath));
                    // console.info('RESET', locationRouting);
                } else {
                    Navi.getNodePath(locationRouting, (path: any[], isDisabled: boolean) => {
                        let nodePath: any[] = path;

                        if (isDisabled) {
                            // console.info('DISABLED', Navi.getNodePath(locationRouting));
                            locationRouting = Navi.getNodeFallback(locationRouting);
                            nodePath = Navi.getNodePath(locationRouting);
                            this.props.onRoutingChange(locationRouting);
                        }
                        this.setState({ nodePath }, () => this.setOpenItems(nodePath));
                    });
                }
            });
        });
    }

    isCurrentNode(item: any): boolean {
        const curEntities: string[] = this.state.curNode.entities || [];
        const curPath: any = this.state.curNode.path || {};
        const entity: string = (item.entities || [])[0];
        const path: any = item.path || {};
        let status: boolean = true;

        Object.keys(path).forEach((key: string) => {
            if ((key || '').toString().startsWith('tab') && path[key] !== curPath[key]) {
                status = false;
            }
        });

        if (entity && curEntities.indexOf(entity) === -1) {
            status = false;
        }

        return status;
    }

    onRoutingChange(data: any): void {
        this.setState({ curNode: data || {} }, () => {
            console.log('onRoutingChange', data);
            this.toggleItem(data.item, data.level);
            this.props.onRoutingChange(this.state.curNode);
        });
    }

    render(): JSX.Element {
        return (
            <div className={classNames(style.wrapper, SectionStyle.getCurrentClass())}>
                <div className={style[`area-${this.props.id}`]}>
                    {this.renderGroup(this.state.navigation, 0)}
                </div>
                {this.state.navigation === null && <WSpinner />}
            </div>
        );
    }

    renderChildren(item: any, level: number): JSX.Element {
        const classNameCurrent: string = this.isCurrentNode(item) ? style.current : null;

        return (
            <div
                className={classNames(style[`level-${level}`], classNameCurrent)}
                style={{
                    color: item.color ? item.color : this.state.color,
                    backgroundColor: item.bgcolor ? item.bgcolor : this.state.backgroundColor,
                    cursor: /*((level && !item.children) || !level) && */item.path && 'pointer',
                    marginLeft: level * (level > 1 ? 15 : 20)
                }}
                onClick={() => !(item.children || []).length
                    ? this.onRoutingChange({ path: item.path || {}, entities: item.entities || [], item: item || {}, level })
                    : this.toggleItem(item, level)
                }
            >
                {item.name}{this.renderToggle(item, level)}
            </div>
        );
    }

    renderGroup(data: any[], level: number): JSX.Element[] {
        return (data || []).map((item: any, index: number) => {
            if (item.disabled || false) {
                return null;
            }
            const children: any[] = item.children || [];
            const key: string = this.getNodeKey(item);

            if (level === 0) {
                return (
                    <div
                        key={`group-${index}`}
                        style={{ color: item.color && item.color, backgroundColor: item.bgcolor && item.bgcolor }}
                    >
                        {this.renderChildren(item, level)}
                        {!!this.state.openItems[key] && !!children.length && this.renderGroup(children, level + 1)}
                    </div>
                );
            }

            return (
                <React.Fragment key={`site-${level}-${index}`}>
                    {this.renderChildren(item, level)}
                    {!!children.length && !!this.state.openItems[key] && this.renderGroup(children, level + 1)}
                </React.Fragment>
            );
        });
    }

    renderToggle(item: any, level: number): JSX.Element {
        const key: string = this.getNodeKey(item);

        return (
            <div style={{ float: 'right' }}>
                {!!(item.children || []).length
                    ? (!!this.state.openItems[key]
                        ? (!level ? '▼' : '▽')
                        : (!level ? '▶' : '▷')
                    )
                    : ''
                }
            </div>
        );
    }

    setOpenItems(nodePath: any[]): void {
        const openItems: any = {};
        nodePath = nodePath || [];

        if ((nodePath[1] || {}).name) {
            let key: string = this.getNodeKey(nodePath[1]);
            openItems[key] = nodePath[1].name;

            nodePath.forEach((node: any, index: number) => {
                if (index > 1 && nodePath[index].name && nodePath[index].path) {
                    key = this.getNodeKey(nodePath[index]);
                    openItems[key] = nodePath[index].name;
                }
            });
            this.setState({ openItems });
        }
    }

    toggleItem(item: any, level: number): void {
        // if (+level > 1) {
        //     return;
        // }
        const key: string = this.getNodeKey(item);
        const name: string = item.name || null;
        const stateOpenItems: any = this.state.openItems || {};
        const openItems: any =  +level === 0 ? {} : stateOpenItems;

        if (!stateOpenItems[key]) {
            openItems[key] = name;
        } else {
            delete openItems[key];
        }
        this.setState({ openItems });
    }
}
